import { Assets } from "assets/Assets";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { defaultHorizontalMargin } from "theme/GlobalElements";
import CategoryCard from "./components/CategoryCard";
import { CategoryCardType } from "./types";

const config: CategoryCardType[] = [
  {
    title: "Климатици за дома и офиса",
    route: "/category?type=Инверторен,Хиперинверторен,Подов,Таванен",
    image: Assets.hereFor.homeAndOffice,
  },
  {
    title: "Колонни климатици",
    route: "/category?type=Колонен",
    image: Assets.hereFor.column,
  },
  {
    title: "Мултисплит системи",
    route: "/category?type=Мултисплит",
    image: Assets.hereFor.multisplit,
  },
  {
    title: "Рециклирани Япония",
    route: "/category?category=Втора%20употреба%20(Япония)",
    image: Assets.hereFor.reciklirani,
  },
  {
    title: "Професионални климатици",
    route: "/category?type=VRV",
    image: Assets.hereFor.professional,
  },
  {
    title: "Аксесоари",
    route: "/accessories",
    image: Assets.hereFor.accessories,
  },
];

interface ProductCategoriesProps {}

const ProductCategories: React.FC<ProductCategoriesProps> = ({}) => {
  return (
    <Container>
      <Title>Търсите</Title>
      <ProductCategoriesContainer>
        {config.map((item, idx) => (
          <CategoryCard key={idx} item={item} />
        ))}
      </ProductCategoriesContainer>
    </Container>
  );
};

const Container = styled.div`
  ${defaultHorizontalMargin};
`;

const Title = styled.h3`
  margin-bottom: 30px;
  text-align: center;

  @media only screen and (${device.laptop}) {
    text-align: left;
  }
`;

const ProductCategoriesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-template-rows: repeat(auto-fit, 250px);
  row-gap: 30px;
  column-gap: 60px;

  @media only screen and (${device.tablet}) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-template-rows: repeat(auto-fit, 340px);
  }

  @media only screen and (${device.laptopL}) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-template-rows: repeat(2, 320px);
  }
`;

export default ProductCategories;
